// PriceReport.js
// Component for the Price List Report

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import ReportCard from './ReportCard';
import dateFormat from 'dateformat';

// Component Class
// Shows Price List Report Card
class PriceReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {}
  }

  // Returns the filename for the downloaded report
  getFilename = () => {
    var dateStr = dateFormat(new Date(), "yyyy.mm.dd");
    return "Carlinhos_Tabela_"+dateStr+".pdf"
  }

  // Returns the processed report object
  getReport = () => {
    return this.props.report.getPriceReport();
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Lista de Preços"
        description="Lista de preços com valores atualizados."
        getReport={this.getReport}
        getFilename={this.getFilename}
      >
        <br />
      </ReportCard>
    );
  }
}

// Required Properties
PriceReport.propTypes = {
  report: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
}

// Exports
export default PriceReport;


// WEBPACK FOOTER //
// ./src/components/ReportView/PriceReport.js